/* eslint-disable css-modules/no-unused-class */
'use client';

import classNames from 'classnames';
import React from 'react';
import SkeletonLoader from '@/components/atoms/skeleton-loader/skeleton-loader';
import ProfileBecomeMemberCard from '@/components/organisms/profile-become-member-card/profile-become-member-card';
import styles from './profile-no-loyalty-wall.module.scss';

export interface ProfileNoLoyaltyWallProps {
  /** The content to show */
  becomeLoyaltyMemberModal?: Content.Components['ProfileNoLoyaltyWallModuleDto']['becomeLoyaltyMemberModal'];
  /** Whether the module is loading */
  isLoading?: boolean;
}

const ProfileNoLoyaltyWall = ({
  becomeLoyaltyMemberModal,
  isLoading = false,
}: ProfileNoLoyaltyWallProps) => {
  if (isLoading) {
    return (
      <div
        className={classNames(styles.component, styles.isLoading)}
        data-brand="onehome"
      >
        <SkeletonLoader className={styles.loader} height="100%" width="100%" />

        <ProfileBecomeMemberCard isLoading />
      </div>
    );
  }

  return (
    <div className={styles.component} data-brand="onehome">
      <ProfileBecomeMemberCard
        becomeLoyaltyMemberModal={becomeLoyaltyMemberModal}
      />
    </div>
  );
};

ProfileNoLoyaltyWall.displayName = 'ProfileNoLoyaltyWall';

export default ProfileNoLoyaltyWall;
